<div id="confirm-modal">
  <div mat-dialog-title class="dialog-title" id="dialogTitle">{{ data.title | translate:locale.language }}</div>
  <div mat-dialog-content>
    <div class="modal-message" [innerHTML]="data.message | translate:locale.language"></div>
    @if (data.requireInput) {
      <mat-form-field style="width: 100%; margin: 0.5rem 0" appearance="outline">
        <mat-label [innerHTML]="data.inputPlaceholder | translate:locale.language"></mat-label>
        <input matInput [formControl]="inputValue">
      </mat-form-field>
    }
    @if (data.warningText?.length) {
      <span>
        <strong class="mat-error" [innerHTML]="data.warningText | translate:locale.language"></strong>
      </span>
    }

  </div>
  <div mat-dialog-actions class="button-row right">
    <button mat-button color="{{ cancelColor }}" id="cancel" [mat-dialog-close]="false">{{ (data.cancel || 'Cancel') | translate:locale.language }}</button>
    <button mat-raised-button [disabled]="okDisabled" color="{{ okColor }}" id="ok" [mat-dialog-close]="okCloseValue">{{ (data.ok || 'Confirm') | translate:locale.language }}</button>
  </div>
</div>